export default __webpack_public_path__ + "static/basic-linked-list-8c508b54ec2b96807e47e74e9a54a36c.png";